import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeService } from 'apps/ubivu-panel/src/app/serveices/node.service';
import { Subject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { cloneDeep, find } from '@ubi-cell/core-utils';
import { LoadingService } from 'libs/shared/src/lib/service/loading.service';
import { AlertBoxComponent } from 'libs/ui-componentes/src/lib/components/alert-box/alert-box.component';
import { TopBarService } from '../top-bar.service';
@Component({
    selector: 'ubi-cell-saved-filter',
    templateUrl: './saved-filter.component.html',
    styleUrls: ['./saved-filter.component.scss'],
    standalone: false
})
export class SavedFilterComponent implements OnInit, OnDestroy {
  totalNodes: (number | string) = 0;
  selectedFilters: any = [];
  suggestedFilters: any = [];
  inputRequestFilter: any = [];
  isViewNode: boolean = false;
  isNodeCount: boolean = false;
  savedFilterCountSub: Subscription;
  removeNodeFilterSub: Subscription;
  period = null;
  startDate = null;
  endDate = null;
  capabilityFilterForWorkOrderSub: Subscription;

  constructor(public dialogRef: MatDialogRef<SavedFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _nodeService: NodeService,
    private _loadingService: LoadingService,
    private _topBarService: TopBarService,
    private dialog: MatDialog,) { }

  ngOnInit(): void {
    this.selectedFilters = [];
    this.suggestedFilters = cloneDeep(this.data['userFilter']);
    this.period = this.data['period'];
    this.startDate = this.data['start_date'];
    this.endDate = this.data['end_date'];
    if (this.data.capability_type != 'notifications') {
      this.getSavedFilterCount(this.data['requestFilter']);
    }
    this.data['filters'].forEach((element, index) => {
      if (!element.userFilter) {
        this.inputRequestFilter.push(element)
      }
    });
    this.dialogRef.backdropClick().subscribe(result => {
      this.close();
    });
  }

  toggle(ref, suggestedFilter: any) {
    if (this.data.capability_type == 'notifications' || this.data.capability_type.includes('power_quality')) {
      const alreadySelectedFilter = find(this.suggestedFilters, (d) => d.selected);
      if (alreadySelectedFilter && !suggestedFilter.selected && suggestedFilter.id != alreadySelectedFilter.id) {
        alreadySelectedFilter.selected = false;
        alreadySelectedFilter.userFilter = false;
      }
    }
    this.isNodeCount = false;
    this.isViewNode = true;
    const currentToggleFilter = find(this.suggestedFilters, { id: suggestedFilter.id });
    currentToggleFilter.selected = !suggestedFilter.selected;
    this.createSelectedFilter();

    if (this.data.capability_type == 'notifications') {
      this.chooseFilter();
    }
  }

  createSelectedFilter() {
    this.selectedFilters = [];
    this.suggestedFilters.forEach(element => {
      if (element.id && element.selected == true) {
        element.userFilter = true;
        this.selectedFilters.push(element);
      }
    });
    this.onfilterchange(this.selectedFilters);
  }

  getSavedFilterCount(filtersOptions) {
    this.totalNodes = 0;
    let params = {
      count_only: true,
      capability_type: this.data.capability_type,
      entity_type: this.data.entity_type,
      filter: filtersOptions,
      q: this.data?.search || null,
      period: this.period,
      start_date: this.startDate,
      end_date: this.endDate
    };

    if (this.data.capability_type.includes('_wo')) {
      this.capabilityFilterForWorkOrderSub?.unsubscribe();

      this.capabilityFilterForWorkOrderSub = this._topBarService.capabilityFilterForWorkOrder.subscribe((res) => {
        if (!res) return;

        const { capabilityPageFilter, selectedDeviceId, showClosedWorkOrders } = res;

        params['filter'] = capabilityPageFilter?.filter
        params['q'] = capabilityPageFilter?.searchString
        params['device_id'] = selectedDeviceId
        params['type'] = this.data.workOrderCapabilityType
        params['wo_filter'] = filtersOptions
        params['wq'] = this.data?.search || null

        params['wo_filter'] = params['wo_filter'].length && params['wo_filter'].filter(filterElement => filterElement && (filterElement?.attribute) != 'work_order_toggle') || [];
        params['wo_filter']?.push({ "attribute": "work_order_toggle", "operator": "=", "value": showClosedWorkOrders });
      });
    }

    this.savedFilterCountSub = this._topBarService.getSavedFilterCount(params).subscribe((response) => {
      if (response.code == 200) {
        this.totalNodes = response?.data?.node_count;
        this.isNodeCount = true;
      }
    });
  }

  onfilterchange(filteData: any) {
    let filtersOptions = [];
    filteData.forEach((filter) => {
      if (filter.payload?.length) {
        filter.payload.forEach((element) => {
          if (element?.attribute == 'date') {
            this.period = (element?.period) || null;
            this.startDate = (element?.start_date) || null;
            this.endDate = (element?.end_date) || null;
          } else {
            filtersOptions.push(element);
          }
        });
      }
    });


    if(this.data?.capability_type == 'wifi' || this.data?.capability_type == 'cameras_video'){
      this.inputRequestFilter?.forEach((filter) =>{
        if (filter.payload?.length) {
          filter.payload.forEach((element) =>{
            filtersOptions.push(element);
          });
        }
      });
    }
    if (this.data.capability_type != 'notifications') {
      filtersOptions = filtersOptions?.length ? filtersOptions : this.data['requestFilter'];
      this.getSavedFilterCount(filtersOptions);
    }
  }

  chooseFilter() {
    this.data['userFilter'].forEach(element => {
      let filterAttribute = find(this.selectedFilters, { id: element.id });
      if (filterAttribute) {
        element['selected'] = true;
        element['userFilter'] = true;
      } else {
        element['selected'] = false;
      }
    });
    this.inputRequestFilter.forEach(async filter => {
      if (this.data.capability_type != 'notifications') {
        this.selectedFilters.push(filter);
      } else if (this.data.capability_type == 'notifications' && filter.id) {
        this.selectedFilters.push(filter);
      }
    });
    this.data['filters'] = this.selectedFilters;
    this.dialogRef.close(this.data);
  }

  removeFilter(filter: any) {
    const dialogRef = this.dialog.open(AlertBoxComponent, {
      autoFocus: false,
      data: {
        title: 'delete_filter',
        content: 'delete_filter_message',
        cancelActionText: 'no_tag',
        confirmActionText: 'yes_tag',
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const index = this.suggestedFilters.indexOf(filter);
        this._loadingService.isLoaderVisible.next("show");
        const reqParams = {
          "type": this.data.capability_type,
        }
        this.removeNodeFilterSub = this._nodeService.removeNodeFilter(filter.id, reqParams).pipe(
          finalize(() => {
            this._loadingService.isLoaderVisible.next("hide");
          })).subscribe(response => {
            if (response) {
              if (index >= 0) {
                this.suggestedFilters.splice(index, 1);
                this.data['userFilter'].splice(index, 1);
                this.createSelectedFilter();
              }
            }
          });
      }
    });
  }

  close() {
    this.data['userFilter'].forEach(element => {
      if (element.selected == true) {
        let attribute = find(this.inputRequestFilter, { id: element.id });
        if (!attribute) {
          this.inputRequestFilter.push(element);
        }
      }
    });
    this.data['filters'] = this.inputRequestFilter;
    this.dialogRef.close(this.data);
  }

  ngOnDestroy(): void {
    this.removeNodeFilterSub?.unsubscribe();
    this.savedFilterCountSub?.unsubscribe();
  }
}
